// Renter-Insurance_v01-theme.ts
export const RENTERS_THEME = {
  colors: {
    primary: "#0d6efd",
    onPrimary: "#ffffff",
    borderPrimary: "#0d6efd",

    success: "#198754",
    successSubtleBg: "#d1e7dd",
    backgroundColor: "silver",
    onSuccess: "#ffffff",
    borderSuccess: "#198754",

    light: "#f8f9fa",
    dark: "#212529",

    // Utility / accents (feel free to expand later)
    cardBorder: "#dee2e6",
    stickyHeaderBg: "#ffffff",
    helpHeaderBg: "#f8f9fa",
    helpHeaderText: "#212529",
    badgeLightBg: "#f8f9fa",
    badgeLightText: "#212529",
  },
  layout: {
    // Prevent language toggle wiggle by fixing its width
    langSwitchWidthPx: 56,
    stickyTopPx: 16,
    progressMinWidthPx: 160,
    progressMinWidthVerticalPx: 180,
    verticalScrollMarginTopPx: 90,
  },
} as const;

export type RentersTheme = typeof RENTERS_THEME;
